import { createElement } from "react";
import { toast } from "react-toastify";

export function notifyLibrarySave(library) {
  if (!library) return; // Allow the frontend to run before the backend is upgraded.
  if (library.status === "saved") {
    toast.success(createElement("div", null,
      "Your analysis has been saved to Library.", createElement("br"),
      createElement("a", { href: `/library?analysis=${library.id}`,
        style: { color: "var(--app-accent)", fontWeight: 600 } }, "View in Library")
    ), { toastId: `library-${library.id}`, autoClose: 6000 });
  } else if (library.status === "failed") {
    toast.warning("Your analysis is ready, but saving failed. Use Retry save beside your result.", { autoClose: 8000 });
  }
}
